import React, { useState, useEffect,} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { GpsBaseURL, Role } from '../../api/DataApis';
import { Link, Navigate, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import "./User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from "../Settings/Loader";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';



  const PendingOrders = () => {
  const [corporateData, setCorporateData] = useState([]);
   const [selectedCorporate, setSelectedCorporate] = useState("");
   const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState("0");
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [selectedUser, setSelectedUser] = useState('');
  const [popupInput, setPopupInput] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [currentPage, setCurrentPage] = useState(1); 
  const [selectStatusType, setselectedStatusType] = useState("");
  const [searchTerms, setSearchTerms] = useState({
    srNo: '',
    name: '',
    email: '',
    phone: '',
    meterTransactions: '',
    rfids: '',
    wallet: '',
    status: '',
    createdDate: '',
    actions: ''
  });

  let navigate = useNavigate();
  const handleSearch = (column, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [column]: value
    }));
  };

  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/orders/pending-orders-list`);
    }
 document.title = "Pending Order";

 const corporateOptions = corporateData.map(corporate => ({
  value: corporate._id,
  label: `${corporate.corporate_name} (${corporate?.email})`,
  _id: corporate._id,
}));

const handlecorporateChange = (selectedOption) => {
  console.log("selectedOption3wrewgfreh", selectedOption);
  if(selectedOption) {
 setSelectedCorporate({ id: selectedOption._id });
  } else {
    setSelectedCorporate(null);
  }
}
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };



  const fetchproducts = async (page) => {
    setLoadings(true);
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/order`);
   
    
    // Prepare query parameters
    const queryParams = [`page=${page}`];
    
    // Add search term to the query params if it's not empty
 queryParams.push(`payment_status=Pending`)
    if (searchQuery) queryParams.push(`searchText=${searchQuery}`);
    if (selectStatusType) queryParams.push(`status=${selectStatusType}`);
    if(selectedCorporate?.id) queryParams.push(`corporate_id=${selectedCorporate?.id}`);
    
    
    const apiUrl = `${apiEndpoint}?${queryParams.join('&')}`;
  
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
     
      setFilteredData(response.data?.data);
      setTotalCount(response.data.totalCount || 0);
      setLimit(response?.data?.limit);
      setPageCount(Math.ceil(response.data.totalCount / response?.data?.limit)); // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchproducts(page);
  }, [searchTerm,  page]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  

  
  const fetchCorporatesData = async () => {
   
    const apiEndpoint = `${GpsBaseURL}/corporate`;
    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      console.log("Countries response", response);
      setCorporateData(response.data.data);
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
     
    }
  };
useEffect(() => {
    if (Role === "false") {
      fetchCorporatesData();  // Only fetch corporate data if Role === "false"
    }
  }, [Role]);
  
  
 const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle submit to fetch filtered data
const handleSearchSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const page = 1; // Always reset to page 1 when searching
  setPage(page); // Ensure pagination resets to the first page

  // Set loading to true while fetching
  setLoadings(true); 

  // Prepare the base URL and query parameters
  let url = `${GpsBaseURL}/order/?page=${page}`;
  //let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/product/`);
  const params = [];

  // Add search term if present
  if (searchQuery.trim()) {
      params.push(`searchText=${searchQuery}`);
  }
  params.push(`payment_status=Pending`);
  if (selectedCorporate?.id) {
    params.push(`corporate_id=${selectedCorporate?.id}`);
}
  //

  if (params.length) {
      url += `&${params.join('&')}`;
  }

  try {
      const res = await axios.get(url, {
          headers: {
              Authorization: `Bearer ${uniqueToken}`, // Include authorization token
          },
      });

      if (res && res?.data && res?.data?.data) {
          setFilteredData(res?.data?.data); // Update filtered data
          setTotalCount(res?.data?.data?.length); // Set total count based on the filtered data length
          setPageCount(Math.ceil(res?.data?.totalCount / res?.data?.limit)); // Update page count based on results
      } else {
          setFilteredData([]); // If no data is returned, set filtered data to empty
          setTotalCount(0); // If no data is returned, set totalCount to 0
      }
      
  } catch (error) {
      console.error("Error fetching filtered data:", error);
  } finally {
      setLoadings(false); // Set loading to false after fetching
  }
};

const handleSelectChange = async (meter) => {
  console.log("meterrr", meter);
  
  try {
    Swal.fire({
      title: 'Processing...',
      text: 'Please wait...',
      allowOutsideClick: false,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      didOpen: () => {
        // Swal.showLoading();
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'The operation was cancelled', 'error');
      }
    });

    Swal.close();
    
    Swal.fire({
      allowOutsideClick: false,
      width: '50%',
      html: `
        <div style="max-width: 100%; overflow-x: auto;">
          <div style="font-weight: bold; margin-bottom: 10px; border: 2px solid #ccc; padding: 10px; border-radius: 5px;">
            <h4>Product Items</h4>
          </div>
          <table style="table-layout: auto; width: 100%; border-collapse: collapse; font-size: 14px; text-align: left;" border="1">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Product Image </th>
                <th>Product Name</th>
               <th>Quantity</th>
                 <th>Price</th>
             </tr>
            </thead>
          <tbody>
      ${
        meter.items?.length > 0 ? 
        meter.items.map((log, index) => {
          return `
            <tr>
              <td>${index + 1}</td>
              <td><img src="${log.product_image}" alt="${log.product_name}" style="max-width: 50px; height: auto;"></td>
              <td>${log?.product_name}</td>
              <td>${log?.quantity}</td>
              <td>${log?.price}
           
         
            </tr>
          `;
        }).join('') : 
        ``
      }
    </tbody>
          </table>
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: false
    });
  } catch (error) {
    console.error('Error:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Something went wrong.',
    });
  }
};

console.log("totalCount", totalCount);
console.log("pagecount", pageCount);
console.log("limit", Limit);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3">Pending Orders({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
   
  </div>
  
  <Link
    className="btn btn-transparent grey-salsa btn-outline btn-sm"
    style={{
      border: "1px solid black",
      borderRadius: "34px",
      display: "inline-flex",
      alignItems: "center",
      overflow: "hidden",
    }}
    to="/product-add"
  >
    <i className="fa fa-plus"></i> Add Order
  </Link>
</div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
  <form className="form-horizontal" role="form" style={{ marginTop: "5px" }}>
    <div
      className="row px-3"
      style={{
        display: "flex",
        alignItems: "center",
        //gap: "10px", // Consistent spacing between filters
        flexWrap: "wrap", // Allow wrapping on smaller screens
      }}
    >
<div className="col-md-2 col-sm-12">
  <div className="form-group">
  <input
    placeholder="Find Data Here"
    className="form-control"
    style={{
      //width: "calc(100% - 150px)", // Increased available width for the input box
      borderRadius: "8px",
      padding: "6px 10px",
      marginRight: "10px",
      height: "38px", // Consistent height
    }}
    value={searchQuery}
    onChange={handleSearchTextChange}
  />
  </div>
</div>
{Role === "false" && (
<div className="col-md-2 col-sm-12"style={{alignItems: "center"}}>
  <div className="form-group">
    <Select
      options={corporateOptions}
      onChange={handlecorporateChange}
      value={corporateOptions?.find(option => option.value === selectedCorporate?.id) || null}
      placeholder="Select Corporate"
      isClearable
    
      styles={{
        control: (base) => ({
          ...base,
          height: '38px', 
          width: '100%', // Make width responsive
          boxShadow: 'none',
          minWidth: '0', // Ensures it can shrink below 165px if needed
          flex: 1, // Allow select to grow and shrink
        }),
      }}
    />
  </div>
</div>
)}
<div className="col-md-2 col-sm-12" style={{ display: "flex", alignItems: "center" }}>

    {/* Search Button */}
    <button
      className="btn btn-primary"
      onClick={handleSearchSubmit} // Calls the handleSearchSubmit function
      style={{
        marginLeft: "10px", // Space between the input and button
        height: "38px", // Consistent height
        width: "80px", // Consistent width for the Search button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Search
    </button>

    {/* Reset Button */}
    <button
      className="btn btn-primary"
      onClick={handleReset} // Calls the handleReset function
      style={{
        marginLeft: "10px", // Space between the buttons
        height: "38px", // Consistent height
        width: "80px", // Slightly smaller width for Reset button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Reset
    </button>

</div>

    </div>
  </form>
</div>



              <div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <Loader /> 
  ) : totalCount === 0 ? (
    <div className="text-center">
      <h5>No User Data Found</h5> {/* Message to indicate no data found */}
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Sr No</th>
    {Role ==="false" && (
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Corporate Name</th>
  )}
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Email</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Mobile</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>OrderID</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Total Price</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Payment Status</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Status</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Order Date</th>
   
  
 
  </tr>
</thead>

        <tbody> 
          {filteredData?.map((user, index) => (
            <tr key={index}>
              <td>{(page - 1) * Limit + index + 1}</td>
              {Role ==="false" &&  (
         <td>{user?.corporate_name}</td>
        )}
       <td>{user?.email}</td>
       <td>{user?.mobile}</td>
       <td>  <Link to=""
                                      title="Meter Transaction Logs"
                                      className="transaction-links"   // Specify the route if needed, or leave empty if not using routing
                                      onClick={(e) => {
                                        e.preventDefault();  // Prevents the default link behavior
                                        handleSelectChange(user);
                                      }}
                                    >{user?.orderId}  </Link></td>
                                    <td>{user?.total_price}</td>
       <td>{user?.payment_status}</td>
       <td>{user?.status}</td>
       <td>{user?.orderDate}</td>
  </tr>
          ))}   
        </tbody>
      </table>
</div>
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>

 </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default PendingOrders;
